import { AuthExtensionApi } from './AuthExtensionApi';
import { createApiRef } from '@backstage/core-plugin-api';

/**
 * The API reference for the AuthExtensionApi.
 * @public
 */
export const authExtensionApiRef = createApiRef<AuthExtensionApi>({
  id: 'plugin.auth-extension',
});
